import React from "react";

import { ProgressBarWidgetIconProps } from "../../../../types/widgets";

export const ProgressBarWidget1 = (props: ProgressBarWidgetIconProps) => (
  <svg
    width={305}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      stroke={props.inactivebarcolor || "#E0E0E0"}
      strokeWidth={12}
      strokeLinecap="round"
      d="M6 6h293"
    />
    <path
      d={`M6 6h${(props.barprogress && props.barprogress) || 0}`}
      stroke={props.activebarcolor || "#909090"}
      strokeWidth={12}
      strokeLinecap="round"
    />
  </svg>
);
